import { setFlatPreviewAvailableAction as setFlatPreviewAvailableOperation } from 'editor/src/store/editorModules/preview/slice';

export default setFlatPreviewAvailableOperation;
